<div class="no-close-2">
  @if (navTitle) {
  <h3>{{ navTitle }}</h3>
  } @for (item of navItems; track item; let itemIndex = $index) {
  <ul class="nav-vertical -menu main-menu-sidebar no-close-2">
    <li class="nav-vertical -menu -item">
      <div
        class="nav-vertical -menu -item -container d-flex justify-content-between"
        (click)="toggleChild('p', item.uniqueId)"
        [ngClass]="{
          '-no-child': !item.children,
          '-active': item.active,
          '-open': item.children && !_closedStates['p'][item.uniqueId]['state']
        }">
        <app-link
          class="nav-vertical -menu -item -link"
          (click)="toggleChild('p', item.uniqueId, $event)"
          [ngClass]="{ '-active': item.active }"
          [to]="item.path"
          [disableRoute]="item.path ? false : true"
          [externaloverride]="item.newTab">
          {{ item.title }}
        </app-link>
        @if (item.children) {
        <button-icon  [name]="_closedStates['p'][item.uniqueId]['icon']"> </button-icon>
        } @if (item.newTab) {
        <app-link [to]="item.path" [externaloverride]="item.newTab">
          <button-icon  (click)="toggleChild('p', item.uniqueId)" name="external-link">
          </button-icon>
        </app-link>
        }
      </div>
      @if (item.children) {
      <ul [@_closed]="_closedStates['p'][item.uniqueId]['state']" class="nav-vertical -menuChild inner-content-bg">
        @for (child of item.children; track child; let childIndex = $index) {
        <li class="nav-vertical -menuChild -item">
          <div
            class="nav-vertical -menuChild -item -container d-flex align-items-start"
            [ngClass]="{ '-hasIcon': child.children, '-active': child.active, '-hasNoIcon': !child.children }">
            @if (child.children) {
            <button-icon (click)="toggleChild('c', child.uniqueId)" size='sm' [name]="_closedStates['c'][child.uniqueId]['icon']">
            </button-icon>
            } @if (child.children) {
            <app-link
              (click)="toggleChild('c', child.uniqueId)"
              class="nav-vertical -menuChild -item -link"
              [ngClass]="{ '-active': child.active }"
              [to]="child.path"
              [disableRoute]="child.path ? false : true">
              {{ child.title }}
            </app-link>
            } @if (!child.children) {
            <app-link
              class="nav-vertical -menuChild -item -link"
              [ngClass]="{ '-active': child.active }"
              [to]="child.path"
              [disableRoute]="child.path ? false : true">
              {{ child.title }}
            </app-link>
            }
          </div>
          @if (child.children) {
          <ul class="nav-vertical -menuGrandchild" [@_closed]="_closedStates['c'][child.uniqueId]['state']">
            @for (grandchild of child.children; track grandchild; let grandChildIndex = $index) {
            <li class="nav-vertical -menuGrandchild -item">
              <app-link
                class="nav-vertical -menuGrandchild -item -link"
                [ngClass]="{ '-active': grandchild.active }"
                [to]="grandchild.path"
                [disableRoute]="grandchild.path ? false : true">
                {{ grandchild.title }}
              </app-link>
            </li>
            }
          </ul>
          }
        </li>
        }
      </ul>
      }
    </li>
  </ul>
  }
</div>
